<template>
      <b-nav-item-dropdown right no-caret>
        <template slot="button-content">
          <a class="nav-link mr20"><icon icon="user"></icon> {{globals.username}}</a>
        </template>
        <b-dropdown-item><a target="_blank" href="/"><icon icon="globe"></icon> {{$t('OPENSITEINNEWWINDOW')}}</a></b-dropdown-item>
        <b-dropdown-item v-on:click.prevent="logout"><a href=""><icon icon="sign-out-alt"></icon> {{$t('LOGOUT')}}</a></b-dropdown-item>
      </b-nav-item-dropdown>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default
{
  name: 'header-dropdown-accnt',
  methods:
  {
    ...mapActions([
      'logout'
    ])
  },
  computed:
  {
    ...mapGetters([
      'globals'
    ])
  }
}
</script>
